export { default as YearIncrease } from "./YearIncrease.svelte";
